import { createListenerMiddleware } from '@reduxjs/toolkit'
import {
  createPendingCAPCE,
  updatePendingCAPCE,
  deletePendingCAPCE,
  finalizePendingCAPCE,
  createPendingVirginia,
  updatePendingVirginia,
  deletePendingVirginia,
  finalizePendingVirginia,
  createPendingCEBrokerKentucky,
  updatePendingCEBrokerKentucky,
  deletePendingCEBrokerKentucky,
  finalizePendingCEBrokerKentucky,
  createPendingCEBrokerTennessee,
  updatePendingCEBrokerTennessee,
  deletePendingCEBrokerTennessee,
  finalizePendingCEBrokerTennessee,
  createPendingCEBrokerFlorida,
  updatePendingCEBrokerFlorida,
  deletePendingCEBrokerFlorida,
  finalizePendingCEBrokerFlorida,
  createPendingNewJersey,
  updatePendingNewJersey,
  deletePendingNewJersey,
  finalizePendingNewJersey,
  createPendingNewYork,
  updatePendingNewYork,
  deletePendingNewYork,
  finalizePendingNewYork,
  fetchEventAccreditations,
} from './accreditation.slice'
import {
  preArchiveEvent,
  reactivateEvent,
  archiveEvent,
  restoreEvent,
  fetchEventCompliances,
  fetchPlanningEventsProgress,
} from './event-pipeline.slice'
import {
  setCourseAccreditationNotPursued,
  clearCourseAccreditationNotPursued,
  setEventAccreditationNotPursued,
  clearEventAccreditationNotPursued,
  fetchCourseAccreditationHealthDashboard,
  fetchEventAccreditationHealthDashboard,
} from './accreditation-health.slice'

export let listenerMiddleware = createListenerMiddleware()

// Point-free functions for refetching accreditations
let refetchFromMetaArg = (action: any, listenerApi: any) => {
  let { eventId } = action.meta.arg
  listenerApi.dispatch(fetchEventAccreditations(eventId))
}

let refetchFromPayload = (action: any, listenerApi: any) => {
  let { eventId } = action.payload
  listenerApi.dispatch(fetchEventAccreditations(eventId))
}

// All create/update actions have eventId in meta.arg
let createAndUpdateActions = [
  createPendingCAPCE,
  updatePendingCAPCE,
  createPendingVirginia,
  updatePendingVirginia,
  createPendingCEBrokerKentucky,
  updatePendingCEBrokerKentucky,
  createPendingCEBrokerTennessee,
  updatePendingCEBrokerTennessee,
  createPendingCEBrokerFlorida,
  updatePendingCEBrokerFlorida,
  createPendingNewJersey,
  updatePendingNewJersey,
  createPendingNewYork,
  updatePendingNewYork,
]

// All delete/finalize actions have eventId in payload
let deleteAndFinalizeActions = [
  deletePendingCAPCE,
  finalizePendingCAPCE,
  deletePendingVirginia,
  finalizePendingVirginia,
  deletePendingCEBrokerKentucky,
  finalizePendingCEBrokerKentucky,
  deletePendingCEBrokerTennessee,
  finalizePendingCEBrokerTennessee,
  deletePendingCEBrokerFlorida,
  finalizePendingCEBrokerFlorida,
  deletePendingNewJersey,
  finalizePendingNewJersey,
  deletePendingNewYork,
  finalizePendingNewYork,
]

// Register listeners for create/update actions
createAndUpdateActions.forEach((action) => {
  listenerMiddleware.startListening({
    actionCreator: action.fulfilled,
    effect: refetchFromMetaArg,
  })
})

// Register listeners for delete/finalize actions
deleteAndFinalizeActions.forEach((action) => {
  listenerMiddleware.startListening({
    actionCreator: action.fulfilled,
    effect: refetchFromPayload,
  })
})

// Event lifecycle transitions: thunks take `eventId` as a plain string arg.
let refetchAfterLifecycleTransition = (action: any, listenerApi: any) => {
  let eventId = action.meta.arg
  listenerApi.dispatch(fetchEventAccreditations(eventId))
  listenerApi.dispatch(fetchEventCompliances())
  listenerApi.dispatch(fetchPlanningEventsProgress())
}

let lifecycleActions = [
  preArchiveEvent,
  reactivateEvent,
  archiveEvent,
  restoreEvent,
]

lifecycleActions.forEach((action) => {
  listenerMiddleware.startListening({
    actionCreator: action.fulfilled,
    effect: refetchAfterLifecycleTransition,
  })
})

// Accreditation "not pursued" flag toggles: refetch the relevant dashboard
// after the flag/unflag mutation settles, rather than chaining a dispatch
// inside the thunk itself.
;[setCourseAccreditationNotPursued, clearCourseAccreditationNotPursued].forEach(
  (action) => {
    listenerMiddleware.startListening({
      actionCreator: action.fulfilled,
      effect: (_action, listenerApi) => {
        listenerApi.dispatch(fetchCourseAccreditationHealthDashboard())
      },
    })
  },
)

;[setEventAccreditationNotPursued, clearEventAccreditationNotPursued].forEach(
  (action) => {
    listenerMiddleware.startListening({
      actionCreator: action.fulfilled,
      effect: (_action, listenerApi) => {
        listenerApi.dispatch(fetchEventAccreditationHealthDashboard())
      },
    })
  },
)
